import { useState, useEffect } from 'react'
import { Picker, Popup, Button, Toast, Tag, Cell, Checkbox, Empty } from 'react-vant'
import { ArrowLeft, FriendsO, Success, Arrow } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import request from '../../api/request'

export default function SportsRegistration() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    // 选择器状态
    const [showMeetPicker, setShowMeetPicker] = useState(false)
    const [showEventPicker, setShowEventPicker] = useState(false)
    const [showClassPicker, setShowClassPicker] = useState(false)

    const [meets, setMeets] = useState([])
    const [events, setEvents] = useState([])
    const [classes, setClasses] = useState([])
    const [students, setStudents] = useState([])
    const [registeredStudentIds, setRegisteredStudentIds] = useState(new Set())

    const [form, setForm] = useState({
        meetId: '',
        meetName: '',
        eventId: '',
        eventName: '',
        classId: '',
        className: '',
        selectedStudents: [] // student_ids
    })

    // 初始化
    useEffect(() => {
        fetchMeets()
        fetchClasses()
    }, [])

    const fetchMeets = async () => {
        try {
            const res = await request.get('/sports/meets/')
            setMeets((res.items || []).map(m => ({ text: m.name, value: m.id })))
        } catch (e) { console.error(e) }
    }

    const fetchClasses = async () => {
        try {
            const res = await request.get('/academic/classes/my/', { params: { page_size: 1000 } })
            setClasses((res.items || []).map(c => ({ text: c.class_name, value: c.id })))
        } catch (e) { console.error(e) }
    }

    const fetchEvents = async (mid) => {
        try {
            const res = await request.get(`/sports/meets/${mid}/events/`)
            setEvents((res.items || []).map(e => ({ text: e.name, value: e.id })))
        } catch (e) { console.error(e) }
    }

    const fetchStudents = async (cid) => {
        try {
            const res = await request.get('/academic/students/', { params: { class_id: cid, page_size: 100 } })
            setStudents((res.items || []).map(s => ({ text: s.real_name, value: s.id, gender: s.gender })))
        } catch (e) { console.error(e) }
    }

    const fetchRegistrations = async (mid, eid) => {
        if (!mid || !eid) return
        try {
            const res = await request.get('/sports/registrations/', {
                params: {
                    sports_meet_id: mid,
                    event_id: eid,
                    page_size: 1000
                }
            })
            const ids = new Set((res.items || []).map(r => r.student_id))
            setRegisteredStudentIds(ids)
        } catch (e) { console.error(e) }
    }

    const onMeetConfirm = (val, opt) => {
        setForm(prev => ({ ...prev, meetId: opt.value, meetName: opt.text, eventId: '', eventName: '' }))
        setShowMeetPicker(false)
        fetchEvents(opt.value)
    }

    const onEventConfirm = (val, opt) => {
        setForm(prev => ({ ...prev, eventId: opt.value, eventName: opt.text }))
        setShowEventPicker(false)
        if (form.meetId) {
            fetchRegistrations(form.meetId, opt.value)
        }
    }

    const onClassConfirm = (val, opt) => {
        setForm(prev => ({ ...prev, classId: opt.value, className: opt.text, selectedStudents: [] }))
        setShowClassPicker(false)
        fetchStudents(opt.value)
    }

    const handleSubmit = async () => {
        if (!form.meetId || !form.eventId || form.selectedStudents.length === 0) {
            return Toast.info('请选择运动会、项目和学生')
        }

        setSubmitting(true)
        try {
            const batchData = {
                sports_meet_id: parseInt(form.meetId),
                event_id: parseInt(form.eventId),
                registrations: form.selectedStudents.map(id => ({ student_id: parseInt(id) }))
            }
            await request.post('/sports/registrations/batch/', batchData)
            Toast.success('报名成功')
            fetchRegistrations(form.meetId, form.eventId)
            setForm(prev => ({ ...prev, selectedStudents: [] }))
        } catch (e) {
            Toast.fail('报名失败，可能已超出限额或重复报名')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="registration-page" style={{ background: 'var(--canvas-bg, #f8fafc)', minHeight: '100vh', paddingBottom: 88 }}>
            {/* 沉浸式星瀚空天蓝页眉 */}
            <div style={{
                background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                padding: '44px 16px 20px',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* 装饰半透圆 */}
                <div style={{
                    position: 'absolute', top: -30, right: -30,
                    width: 140, height: 140, borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.08)'
                }} />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <div
                        onClick={() => navigate(-1)}
                        style={{
                            width: 36, height: 36, borderRadius: '50%',
                            background: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        <ArrowLeft color="#fff" fontSize={18} />
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
                            运动会报名
                        </h1>
                        <p style={{ margin: '2px 0 0', fontSize: 11.5, color: 'rgba(255,255,255,0.85)', fontWeight: 400 }}>
                            项目选报 · 参赛队员与名单快速录入
                        </p>
                    </div>

                    <div style={{ width: 36 }} />
                </div>
            </div>

            <div style={{ padding: '14px 16px' }}>
                {/* 筛选选择器卡片 */}
                <div style={{
                    background: '#ffffff',
                    borderRadius: 16,
                    padding: '8px 16px',
                    boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                    border: '1px solid #f1f5f9',
                    marginBottom: 14
                }}>
                    <div
                        onClick={() => setShowMeetPicker(true)}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f8fafc', cursor: 'pointer' }}
                    >
                        <span style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>运动会</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ fontSize: 14, color: form.meetName ? '#056b4f' : '#94a3b8', fontWeight: form.meetName ? 700 : 400 }}>
                                {form.meetName || '点击选择运动会'}
                            </span>
                            <Arrow style={{ fontSize: 12, color: '#94a3b8' }} />
                        </div>
                    </div>

                    <div
                        onClick={() => form.meetId && setShowEventPicker(true)}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f8fafc', cursor: 'pointer' }}
                    >
                        <span style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>比赛项目</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ fontSize: 14, color: form.eventName ? '#056b4f' : '#94a3b8', fontWeight: form.eventName ? 700 : 400 }}>
                                {form.eventName || (form.meetId ? '点击选择比赛项目' : '请先选择运动会')}
                            </span>
                            <Arrow style={{ fontSize: 12, color: '#94a3b8' }} />
                        </div>
                    </div>

                    <div
                        onClick={() => setShowClassPicker(true)}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', cursor: 'pointer' }}
                    >
                        <span style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>报名班级</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ fontSize: 14, color: form.className ? '#056b4f' : '#94a3b8', fontWeight: form.className ? 700 : 400 }}>
                                {form.className || '点击选择班级'}
                            </span>
                            <Arrow style={{ fontSize: 12, color: '#94a3b8' }} />
                        </div>
                    </div>
                </div>

                {form.classId && (
                    <div style={{
                        background: '#ffffff',
                        borderRadius: 16,
                        padding: 16,
                        boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
                        border: '1px solid #f1f5f9'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
                            <div style={{ width: 4, height: 16, background: '#056b4f', borderRadius: 2 }} />
                            <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>选择参赛学生</span>
                            <span style={{ fontSize: 12, color: '#64748b', marginLeft: 'auto' }}>
                                已选 {form.selectedStudents.length} 人
                            </span>
                        </div>

                        {students.length > 0 ? (
                            <Checkbox.Group
                                value={form.selectedStudents}
                                onChange={v => setForm(prev => ({ ...prev, selectedStudents: v }))}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {students.map((s, idx) => {
                                        const isRegistered = registeredStudentIds.has(s.value)
                                        const isLast = idx === students.length - 1;
                                        return (
                                            <div
                                                key={s.value}
                                                onClick={() => {
                                                    if (isRegistered) return
                                                    const current = form.selectedStudents || [];
                                                    const next = current.includes(s.value)
                                                        ? current.filter(id => id !== s.value)
                                                        : [...current, s.value];
                                                    setForm(prev => ({ ...prev, selectedStudents: next }));
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '12px 0',
                                                    borderBottom: isLast ? 'none' : '1px solid #f8fafc',
                                                    cursor: isRegistered ? 'default' : 'pointer'
                                                }}
                                            >
                                                <Checkbox name={s.value} disabled={isRegistered} style={{ marginRight: 10 }} />
                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontSize: 15, fontWeight: 600, color: isRegistered ? '#94a3b8' : '#0f172a' }}>
                                                        {s.text}
                                                    </span>
                                                    <span style={{
                                                        background: s.gender === 'male' ? '#f0fdf4' : '#fff7ed',
                                                        color: s.gender === 'male' ? '#056b4f' : '#ea580c',
                                                        fontSize: 10,
                                                        fontWeight: 700,
                                                        padding: '1px 6px',
                                                        borderRadius: 4
                                                    }}>
                                                        {s.gender === 'male' ? '男' : '女'}
                                                    </span>
                                                </div>
                                                {isRegistered && (
                                                    <span style={{
                                                        background: '#e8f9f0',
                                                        color: '#00b578',
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                        padding: '2px 8px',
                                                        borderRadius: 6
                                                    }}>
                                                        已报名
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            </Checkbox.Group>
                        ) : (
                            <Empty description="该班级暂无学生数据" />
                        )}
                    </div>
                )}
            </div>

            {/* 底部确认栏 */}
            <div style={{
                position: 'fixed',
                bottom: 0, left: 0, right: 0,
                padding: '12px 16px',
                background: '#ffffff',
                boxShadow: '0 -4px 16px rgba(15, 23, 42, 0.06)',
                zIndex: 40,
                borderTop: '1px solid #e2e8f0'
            }}>
                <Button
                    block
                    round
                    loading={submitting}
                    onClick={handleSubmit}
                    disabled={form.selectedStudents.length === 0}
                    style={{
                        background: form.selectedStudents.length === 0 ? '#94a3b8' : 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: 15,
                        fontWeight: 700,
                        height: 44,
                        boxShadow: form.selectedStudents.length === 0 ? 'none' : '0 4px 14px rgba(5, 107, 79, 0.35)'
                    }}
                >
                    确定报名 ({form.selectedStudents.length}人)
                </Button>
            </div>

            <Popup visible={showMeetPicker} round position="bottom">
                <Picker title="选择运动会" columns={meets} onConfirm={onMeetConfirm} onCancel={() => setShowMeetPicker(false)} />
            </Popup>
            <Popup visible={showEventPicker} round position="bottom">
                <Picker title="选择比赛项目" columns={events} onConfirm={onEventConfirm} onCancel={() => setShowEventPicker(false)} />
            </Popup>
            <Popup visible={showClassPicker} round position="bottom">
                <Picker title="选择班级" columns={classes} onConfirm={onClassConfirm} onCancel={() => setShowClassPicker(false)} />
            </Popup>
        </div>
    )
}
